import { render } from "./ResetView.vue?vue&type=template&id=6f179dfc&lang=true"
import script from "./ResetView.vue?vue&type=script&lang=js"
export * from "./ResetView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__